module.exports = __webpack_public_path__ + "static/media/cogwheel.1bd7b7da.svg";